import React, { useState, useRef, useEffect } from "react";
import moment from 'moment';
import {
  Cascader,
  Table,
  Select,
  Button,
  DatePicker,
  Pagination,
  message,
} from "antd";
import * as echarts from "echarts";
import Analysisapi from "@/api/analysis";
import stationApi from "@/api/station";

const columns = [
  {
    title: "设备名称",
    dataIndex: "deviceName",
    key: "deviceName",
    width: 120,
  },
  {
    title: "累计能耗",
    dataIndex: "energyAll",
    key: "energyAll",
    width: 120,
  },
  {
    title: "最大能耗",
    dataIndex: "energyMax",
    key: "energyMax",
    width: 120,
  },
  {
    title: "最小能耗",
    dataIndex: "energyMin",
    key: "energyMin",
    width: 120,
  },
  {
    title: "平均能耗",
    dataIndex: "energyAvg",
    key: "energyAvg",
    width: 120,
  },
];

const { Option } = Select;
const { RangePicker } = DatePicker;

export default function CollectivityEnergy() {
  const [energyType, setEnergyType] = useState();
  const [energyTypeList, setEnergyTypeList] = useState([]);
  const [device, setDevice] = useState([]);
  const [dateRange, setDateRange] = useState([
    moment().subtract(1, "month"),
    moment(),
  ]);
  const [dataSource, setDataSource] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageNum, setPageNum] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(0);
  const [deviceLs, setDeviceLs] = useState([]);
  const [energyId, setEnergyId] = useState(null);
  const [lineTypeList, setLineTypeList] = useState([]);

  const fieldNames = {
    label: "itemName",
    value: "id",
    children: "child",
  };

  // 查询设备
  const getDevice = (stationId = "61") => {
    stationApi.getDeviceByStationId({ stationId }).then((res) => {
      if (res.status !== "0") return;
      setDeviceLs(res.data ? res.data : []);
    });
  };

  // 获取能耗类型列表
  const fetchEnergyTypeList = async () => {
    try {
      const res1 = await Analysisapi.deviceClassifyList({
        classifyName: "",
        pageNum: 1,
        pageSize: 100,
      });
      setEnergyTypeList(res1?.data?.data || []);
      if ((res1?.data?.data || []).length > 0) {
        setEnergyType(res1.data.data[0].id);
      }
    } catch {
      setEnergyTypeList([]);
    }
  };

  useEffect(() => {
    // fetchEnergyTypeList();
    selectEnergyList();
    getDevice();
  }, []);

  useEffect(() => {
    if (lineTypeList.length && dateRange && dateRange[0] && dateRange[1]) {
      handleQuery({ pageNum: 1, pageSize });
    }
    // eslint-disable-next-line
  }, [lineTypeList]);


  const selectEnergyList = () => {
    Analysisapi.selectEnergyList().then((res) => {
      if (res.status == 0 && res.data) {
        setLineTypeList(res.data);
      }
    });
  }

  // 查询接口
  const handleQuery = async ({ pageNum, pageSize }) => {
    if (!dateRange || !dateRange[0] || !dateRange[1]) {
      message.warning("请选择时间范围");
      return;
    }
    setLoading(true);
    try {
      const startTime = dateRange[0].format("YYYY-MM-DD HH:mm:ss");
      const endTime = dateRange[1].format("YYYY-MM-DD HH:mm:ss");
      const params = {
        energyId: energyId || null,
        startTime,
        endTime,
        pageNum,
        pageSize,
      };
      const res = await Analysisapi.energyCensusOverall(params);
      // 适配接口返回结构
      const rawList = res?.data?.data || [];
      const tableList = rawList.map((row, idx) => ({
        key: row.gatherDevId || idx,
        deviceName: row.deviceName || '',
        energyAll: row.energyAll ?? '',
        energyMax: row.energyMax ?? '',
        energyMin: row.energyMin ?? '',
        energyAvg: row.energyAvg ?? '',
      }));
      setDataSource(tableList);
      setTotal(Number(res?.data?.total) || 0);
      setPageNum(pageNum);
      setPageSize(pageSize);
    } catch (e) {
      setDataSource([]);
      setTotal(0);
    } finally {
      setLoading(false);
    }
  };


  const setSelectedDeviceIds = (value) => {
    setDevice(value);
  };

  return (
    <div style={{ background: "#fff", padding: 24 }}>
      <div
        style={{
          marginBottom: 16,
          display: "flex",
          alignItems: "center",
          flexWrap: "wrap",
          gap: 8,
        }}
      >
        <span>能耗类型</span>
        <Select
          value={energyId}
          style={{ width: 160 }}
          onChange={setEnergyId}
          placeholder="请选择能耗类型"
          loading={!lineTypeList.length}
          allowClear
        >
          <Option value={null}>全部类型</Option>
          {lineTypeList.map((item) => (
            <Option value={item.id} key={item.id}>
              {item.name}
            </Option>
          ))}
        </Select>
        <span>时间</span>
        <RangePicker
          showTime={{ format: "HH:mm:ss" }}
          value={dateRange}
          onChange={setDateRange}
          style={{ minWidth: 220 }}
          placeholder={["开始时间", "结束时间"]}
        />
        <Button style={{ marginLeft: 8 }} onClick={() => setDateRange(null)}>
          重置
        </Button>
        <Button
          type="primary"
          onClick={() => {
            handleQuery({ pageNum, pageSize });
          }}
        >
          查询
        </Button>
      </div>
      <Table
        columns={columns}
        dataSource={dataSource}
        bordered
        pagination={false}
        scroll={{ x: "max-content" }}
        loading={loading}
        rowKey={(record) =>
          `${record.deviceName || ""}_${record.energyParam || ""}`
        }
      />
      <div style={{ marginTop: 16, textAlign: "right" }}>
        <Pagination
          current={pageNum}
          pageSize={pageSize}
          total={total}
          showSizeChanger
          showTotal={(t) => `共${t}条`}
          onChange={(page, size) =>
            handleQuery({ pageNum: page, pageSize: size })
          }
        />
      </div>
    </div>
  );
}
